import { createContext } from 'react';
import { ICreateCredentials } from 'types';

export type TTypeOfModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';

export interface ICreateCredentialsState {
	credentialName: string;
	apiKey: string;
	apiSecret: string;
	dataForSubmit: Nullable<ICreateCredentials>;
	typeOfModalWindow: TTypeOfModalWindow;
}

export const createCredentialsInitialState: ICreateCredentialsState = {
	credentialName: '',
	apiKey: '',
	apiSecret: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface ICreateCredentialsContext extends ICreateCredentialsState {
	changeCredentialName(value: string): void;
	changeApiKey(value: string): void;
	changeApiSecret(value: string): void;
	changeTypeOfModalWindow(value: TTypeOfModalWindow): void;
	setDataForSubmit(value: Nullable<ICreateCredentials>): void;
	resetFields(): void;
}

export const CreateCredentialsContext = createContext<ICreateCredentialsContext>({
	changeCredentialName: () => undefined,
	changeApiKey: () => undefined,
	changeApiSecret: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...createCredentialsInitialState,
});
